<template>
	<div class="user-row" @mouseover="showEditButton = true" @mouseleave="showEditButton = false">
		<img v-if="icon" :src="icon" class="file-icon rounded" width="40" height="40" />
		<span v-if="!isEditing">
			<router-link :to="{ name: 'view-post', params: { group: rowData.group.slug, post: rowData.slug }}">{{ rowData.title }}</router-link>
		</span>
		<button v-if="showEditButton && !isEditing" @click="isEditing = (isEditing)? false : true;" class="btn btn-tiny">
			<i class="icon ion-md-create"></i>
		</button>

		<div class="form__group" v-if="isEditing">
			<input type="text" class="form__control edit-inline" v-model="rowData.title">
		</div>
		<button v-if="isEditing" @click="savePost" class="btn btn-tiny">
			Save
		</button>
		<button v-if="isEditing" @click="isEditing = false;rowData.title = originalTitle;" class="btn btn-tiny">
			<i class="icon ion-md-close"></i>
		</button>
	</div>
</template>

<script>
	export default {
		name: 'ColumnFileName',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		data () {
            return {
            	originalTitle: this.rowData.title,
            	isEditing: false,
            	showEditButton: false,
                fileIcons: {
                	'application/pdf' : '/images/file-icons/pdf.svg',
                	'application/zip' : '/images/file-icons/zip.svg',
                	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : '/images/file-icons/xlsx.svg',
                	'application/vnd.openxmlformats-officedocument.wordprocessingml.documentapplication/vnd.openxmlformats-officedocument.wordprocessingml.document' : '/images/file-icons/docx.svg',
                	'application/vnd.openxmlformats-officedocument.wordprocessingml.document' : '/images/file-icons/docx.svg',
                	'application/msword' : '/images/file-icons/docx.svg'
                }
            }
        },
		computed: {
			icon: function () {
				if(this.rowData.meta){
					if( this.rowData.meta.thumbnail !== '' && this.rowData.meta.thumbnail !== null && typeof this.rowData.meta.thumbnail != 'undefined'){
						return this.rowData.meta.thumbnail;
					}

					if( this.rowData.meta.type in this.fileIcons ){
						return this.fileIcons[ this.rowData.meta.type ];
					}
				}

				return '/images/file-icons/default.svg';
			},
		},
		methods: {
			savePost(){
				axios.put('/api/groups/' + this.rowData.group.slug + "/posts/" + this.rowData.slug, this.rowData).then((response) => {
                    this.rowData = response.data;
                    this.originalTitle = response.data.title;
                    this.isEditing = false;
                    //this.$router.push({ name: 'view-document', params: { pageSlug: response.data.breadcrumbs }});
                }, (response) => {
                    this.error = response;
                });
			}
        }
	}
</script>

<style lang="scss">
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";

	.user-row {
		@include display-flex;
		@include align-items(center);
		
		button{
			margin-left: 7px;
		}
	}

	.file-icon {
		margin-right: 1rem;
	}

	.edit-inline{
		width: 300px;
	}

</style>
